// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuWorkspaceNotification{z-index:var(--salt-zIndex-notification);position:absolute}.vuuWorkspaceNotification .vuuWorkspaceNotification-content{background:var(--salt-container-primary-background);justify-content:center;align-items:center;display:flex}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
